var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNgageLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 127,
    viewBox: "0 0 516 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.2 41.66L286.57 37.28H302.94C303.04 37.78 303.11 38.28 303.14 38.79C303.12 55.99 303.24 73.2 302.99 90.39C302.89 97.66 301.09 104.56 295.61 109.93C291.71 113.53 286.73 115.73 281.44 116.18C273.14 117.31 264.7 116.88 256.56 114.9C255.22 114.8 254.21 113.63 254.31 112.28C254.31 112.19 254.33 112.09 254.35 112C254.48 107.84 254.39 103.65 254.39 99.38C257.21 100.15 260.07 100.77 262.95 101.22C266.48 101.65 270.05 101.75 273.59 101.5C279.25 101.3 283.88 96.9 284.38 91.26C284.61 89.9 284.67 88.51 284.78 87.42C281.76 88.86 278.63 90.05 275.41 90.97C258.63 94.42 242.94 84.68 242.73 64.95C242.61 53.49 246.96 44.43 257.4 39.04C264.37 35.36 272.62 34.97 279.91 37.97C282.1 39.03 284.2 40.25 286.19 41.65L286.2 41.66ZM284.43 64.14C284.43 63.4 284.48 62.65 284.43 61.92C283.92 55.57 280.19 51.57 274.31 51C268.77 50.47 263.68 54.08 262.36 59.49C261.81 61.71 261.63 64 261.84 66.28C262.15 72.46 267.41 77.21 273.59 76.9C274.88 76.83 276.15 76.55 277.35 76.05C282.03 74.41 284.46 70.35 284.42 64.14H284.43Z",
    fill: "#2C2828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93 99.6C122.25 100.35 126.25 101.31 130.32 101.67C133.27 101.89 136.23 101.7 139.13 101.12C143.47 100.37 146.86 96.96 147.59 92.62C148.01 90.87 148.19 89.05 148.55 86.84C147.76 87.28 147.31 87.47 146.92 87.74C137.55 94.44 117.51 93.52 109.69 78.92C103.41 67.19 104.87 47.75 119.91 39.58C127.65 35.09 137.13 34.78 145.15 38.75C146.74 39.66 148.26 40.69 149.69 41.84L150.13 37.28H166.44C166.55 37.71 166.62 38.15 166.66 38.59C166.64 55.93 166.71 73.28 166.5 90.62C166.36 94.12 165.73 97.59 164.63 100.91C161.93 109.67 155.51 114.37 146.74 115.9C137.94 117.4 128.92 117.08 120.25 114.95C118.81 114.85 117.72 113.61 117.82 112.17C117.82 112.04 117.85 111.9 117.88 111.77C118.04 107.66 117.93 103.55 117.93 99.59V99.6ZM148 64.14C148 63.47 148.04 62.79 148 62.12C147.63 55.7 143.65 51.42 137.66 51C131.81 50.56 126.6 54.68 125.68 60.48C125.33 62.26 125.22 64.08 125.34 65.89C125.51 72.15 130.72 77.08 136.97 76.91C138.39 76.87 139.8 76.56 141.11 76.01C145.64 74.35 148.01 70.27 147.99 64.15L148 64.14Z",
    fill: "#2C2828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M468.18 92.69C461.67 92.98 455.23 91.28 449.71 87.82C440.7 81.93 437.34 73.26 437.83 62.83C438.31 49.54 448.3 38.53 461.48 36.77C467.53 35.68 473.75 35.93 479.69 37.51C493.75 41.4 500.36 53.03 499.23 66.67C497.84 83.45 484.96 92.3 470.01 92.69C469.4 92.72 468.78 92.7 468.18 92.7V92.69ZM463.06 52.61V76.3L479.23 64.45L463.06 52.61Z",
    fill: "url(#paint0_linear_4419_108)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.76 91.65H218.16L217.57 86.85C215.02 88.56 212.33 90.03 209.52 91.26C194.45 96.36 176.34 88.23 174.7 68.25C173.94 61.78 175.11 55.23 178.06 49.43C181.91 41.95 189.37 36.99 197.76 36.34C203 35.52 208.36 36.41 213.05 38.87C214.7 39.91 216.3 41.03 217.84 42.23L218.17 37.35H234.76V91.65ZM193.6 64.75C193.6 65.15 193.58 65.56 193.6 65.96C194.01 72.7 198.14 77.07 204.5 77.53C210.58 77.93 215.91 73.47 216.57 67.41C216.84 65.82 216.91 64.2 216.77 62.59C216.08 54.49 209.44 49.64 201.99 51.7C196.75 53.15 193.54 58.13 193.61 64.74L193.6 64.75Z",
    fill: "#2C2828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.91 69.79C330.36 72.7 332.22 75.2 334.88 76.45C339.25 78.51 344.16 79.12 348.9 78.2C353.5 77.48 358 76.09 362.71 74.95C362.78 75.34 362.81 75.73 362.82 76.12C362.84 79.49 362.71 82.87 362.88 86.23C363.1 87.72 362.14 89.12 360.67 89.45C355.59 91.46 350.19 92.55 344.72 92.68C338.65 93.12 332.56 92.3 326.83 90.27C318.62 87.35 312.72 80.1 311.54 71.47C310.42 65.48 310.83 59.31 312.73 53.52C315.77 43.75 324.59 36.91 334.81 36.42C338.9 36.11 343.01 36.32 347.04 37.05C357.53 39.24 363.21 46.33 365.35 56.52C365.79 58.7 366.06 60.91 366.14 63.13C366.22 65.27 365.98 67.43 365.87 69.79H329.93H329.91ZM330.15 58.74H347.51C347.49 54.14 343.74 50.42 339.14 50.44C339.04 50.44 338.93 50.44 338.83 50.44C334.17 50.39 330.31 54.07 330.16 58.73L330.15 58.74Z",
    fill: "#2C2828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4 91.64H48.29V89.36C48.29 80.52 48.33 71.68 48.26 62.84C48.26 60.62 48.03 58.4 47.57 56.23C47.09 53.06 44.27 50.79 41.07 51C37.75 50.52 34.62 52.68 33.9 55.96C33.24 59.19 32.9 62.47 32.88 65.76C32.74 73.59 32.83 81.41 32.83 89.24V91.6H14.52V37.31H31.1L31.55 42.72C32.19 42.11 32.6 41.74 32.99 41.34C39.95 34.19 54.66 34.31 61.46 41.59C64.73 45.18 66.52 49.88 66.46 54.73C66.68 66.8 66.55 78.88 66.56 90.96C66.53 91.19 66.48 91.42 66.41 91.64H66.4Z",
    fill: "#2C2828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.38 51.25H400.39V37.3H426.91V71.8601C426.91 77.18 428.19 78.39 433.56 78.1C433.89 78.08 434.22 78.1 434.73 78.1C434.82 78.62 434.88 79.1401 434.91 79.6601C434.93 81.9501 434.91 84.25 434.91 86.5401C434.91 91.59 434.91 91.7301 429.87 92.0801C426.92 92.3101 423.94 92.2201 421.01 91.8001C414.22 91.2601 408.94 85.66 408.8 78.85C408.43 75.1 408.43 71.3101 408.39 67.5401C408.34 62.2101 408.39 56.8801 408.39 51.25H408.38Z",
    fill: "url(#paint1_linear_4419_108)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.74 55.51H99.75V69.37H73.74V55.51Z",
    fill: "#2C2828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M384.64 92.69C379.07 92.96 374.33 88.66 374.06 83.08C374.04 82.7 374.05 82.3299 374.06 81.9499C373.9 76.1699 378.46 71.35 384.25 71.19C384.43 71.19 384.61 71.19 384.79 71.19C390.5 71.07 395.23 75.6 395.35 81.3C395.35 81.62 395.35 81.94 395.33 82.26C395.49 87.86 391.07 92.53 385.47 92.69C385.19 92.69 384.91 92.69 384.63 92.68L384.64 92.69Z",
    fill: "url(#paint2_linear_4419_108)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M426.96 18.56C427.26 24.18 422.95 28.98 417.33 29.29C417 29.31 416.67 29.31 416.35 29.29C410.63 29.47 405.84 24.98 405.66 19.27C405.66 19.02 405.66 18.78 405.66 18.53C405.57 12.64 410.28 7.79004 416.17 7.71004C416.25 7.71004 416.33 7.71004 416.41 7.71004C422.07 7.54004 426.8 11.99 426.97 17.65C426.97 17.95 426.97 18.26 426.96 18.56Z",
    fill: "url(#paint3_linear_4419_108)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M503.6 30.06C504.47 30.57 505.15 31.27 505.65 32.17C506.15 33.07 506.4 34.07 506.4 35.18C506.4 36.2901 506.15 37.2901 505.65 38.18C505.15 39.0701 504.47 39.76 503.6 40.2701C502.73 40.7801 501.74 41.03 500.63 41.03C499.52 41.03 498.52 40.7801 497.65 40.2701C496.77 39.76 496.08 39.0701 495.59 38.18C495.1 37.2901 494.84 36.2901 494.84 35.18C494.84 34.07 495.09 33.06 495.59 32.17C496.09 31.27 496.77 30.57 497.65 30.06C498.53 29.55 499.52 29.3 500.63 29.3C501.74 29.3 502.73 29.55 503.6 30.06ZM504.04 38.69C504.91 37.77 505.34 36.6 505.34 35.18C505.34 33.76 504.91 32.59 504.04 31.67C503.17 30.75 502.04 30.3 500.63 30.3C499.22 30.3 498.06 30.76 497.19 31.67C496.32 32.59 495.89 33.76 495.89 35.18C495.89 36.6 496.32 37.77 497.19 38.69C498.06 39.61 499.2 40.07 500.63 40.07C502.06 40.07 503.17 39.61 504.04 38.69ZM502.76 35.1101C502.49 35.4301 502.11 35.6401 501.62 35.7401L503.38 38.25L501.89 38.28L500.28 35.7901H499.61V38.28H498.35V31.99H501.07C501.71 31.99 502.23 32.16 502.61 32.5C502.99 32.84 503.18 33.3 503.18 33.89C503.18 34.38 503.04 34.78 502.77 35.1L502.76 35.1101ZM499.6 34.7401H500.97C501.24 34.7401 501.47 34.6701 501.64 34.5401C501.81 34.4001 501.9 34.2 501.9 33.93C501.9 33.66 501.81 33.4601 501.64 33.3301C501.46 33.2001 501.24 33.14 500.97 33.14H499.6V34.75V34.7401Z",
    fill: "url(#paint4_linear_4419_108)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4419_108",
    x1: 411.53,
    y1: 0.430026,
    x2: 496.46,
    y2: 95.5501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FAA628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E33A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D03797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BA33E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2C88D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAE9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4419_108",
    x1: 385.22,
    y1: 23.92,
    x2: 470.15,
    y2: 119.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FAA628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E33A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BA33E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2C88D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAE9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4419_108",
    x1: 356.07,
    y1: 49.95,
    x2: 440.99,
    y2: 145.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FAA628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E33A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BA33E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2C88D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAE9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4419_108",
    x1: 405.23,
    y1: 6.06003,
    x2: 490.16,
    y2: 101.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FAA628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E33A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BA33E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2C88D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAE9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4419_108",
    x1: 443.84,
    y1: -28.42,
    x2: 528.77,
    y2: 66.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FAA628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E33A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BA33E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2C88D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AAE9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgageLogoDark);
export default __webpack_public_path__ + "static/media/ngage-logo-dark.da6da8a9a2c6ed1d255e7b8469b0d131.svg";
export { ForwardRef as ReactComponent };